import ToastContainers from "./Utils/ToastContainer";
import PageNotFound404 from "./Errors/PageNotFound404";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import Doctors from "./Pages/Doctors";
import Appointment from "./Pages/Appointment";
import Contact from "./Pages/Contact";
import Pages from "./Pages/Pages";
import Hospitals from "./Pages/Hospitals";
import Blog from "./Pages/Blog";
import Careers from "./Pages/Careers";
import Donate from "./Pages/Donate";
import ScrollToTop from "./Utils/ScrollToTop";
import './App.css';

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        {/* ToastContainer */}
        <ToastContainers />

        {/* Routes */}
        <Routes>

          {/* Web Routes */}
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/services' element={<Services />} />
          <Route path='/doctors' element={<Doctors />} />
          <Route path='/appointment' element={<Appointment />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/pages' element={<Pages />} />
          <Route path='/hospitals' element={<Hospitals />} />
          <Route path='/blog' element={<Blog />} />
          <Route path='/careers' element={<Careers />} />
          <Route path='/donate' element={<Donate />} />

          <Route path='*' element={<PageNotFound404 />} />

        </Routes>

      </BrowserRouter>
    </>
  );
}

export default App;
